import { useQuery } from '@tanstack/react-query';
import { Notifications, type NotificationItem } from './api';
import { useNotifications } from '@/store/notifications';
import { useBackendOnline } from '@/store/connection';

/**
 * Bildirim verisi + okunmamış sayısı. Topbar badge + NotificationDrawer ortak
 * kullanır. 60s polling (WS notification_new event'i anında invalidate eder,
 * polling sadece güvenlik ağı).
 */
export function useNotificationsFeed() {
  const lastSeenId = useNotifications((s) => s.lastSeenId);
  const backendOnline = useBackendOnline();

  const query = useQuery<NotificationItem[]>({
    queryKey: ['notifications'],
    queryFn: () => Notifications.listMine(50),
    refetchInterval: 60_000,
    staleTime: 30_000,
    enabled: backendOnline, // backend offline'ken poll'u durdur
  });

  const items = query.data ?? [];
  const unread = items.filter((n) => n.id > lastSeenId).length;
  const maxId = items.length > 0 ? Math.max(...items.map((n) => n.id)) : 0;

  return { ...query, items, unread, maxId };
}
